import { Component, Input, OnInit, inject } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UserService} from '../../service/user.service';
import {GlobalValidator} from '../../global.validator';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Logger} from '../../logging/default-log.service';
import {ApplicationService} from '../../service/application.service';
import {Administration} from '../../classes/administration';
import {ConfigurationHelper} from '../../helper/configuration.helper';
import {ShopSettings} from '../../classes/shop.settings';
import {CookieService} from '../../service/cookie.service';
import {CookieBannerComponent} from '../cookies/cookie.banner.component';
import {Message} from '../../classes/message';
import {RedirectService} from '../../service/redirect.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'login-component',
    templateUrl: 'login.component.html',
    standalone: true,
    imports: [NgClass, FormsModule, ReactiveFormsModule]
})
export class LoginComponent implements OnInit {
	applicationService = inject(ApplicationService);
	protected cookieService = inject(CookieService);
	private redirectService = inject(RedirectService);
	private route = inject(ActivatedRoute);
	private userService = inject(UserService);
	private logger = inject(Logger);


	private windowObj;
	loginForm: UntypedFormGroup;
	passwordFieldType: string = 'password';
	formError: string;
	returnUrl: string;
	shopForgotPasswordUrl: string;
	@Input() successRedirect: string = '/products';
	shopSettings: ShopSettings = ConfigurationHelper.getSettings();
	cookieStatementUrl: string;

	constructor() {
		const formBuilder = inject(UntypedFormBuilder);


		this.windowObj = <any>window;

		this.loginForm = formBuilder.group({
			'email': [null, Validators.compose([Validators.required, GlobalValidator.mailFormat])],
			'password': [null, Validators.required]
		});
	}

	ngOnInit() {
		this.returnUrl = this.getReturnUrl();
		this.shopForgotPasswordUrl = ConfigurationHelper.getWebshopUrl('/forgot-password');
	}

	isShowRegisterBlock() {
		// Can be null if we're on the 'CMS website' login page.
		if (!this.shopSettings) {
			return true;
		}

		return !this.shopSettings.kvkShop;
	}

	onSubmit(value: any) {
		if (!this.loginForm.valid) {
			return;
		}

		this.userService.login(value.email, value.password).subscribe((result: Administration) => {
			if (this.returnUrl) {
				window.location.href = this.redirectService.getWebshopUrlForRelativePath(this.returnUrl);
			} else if (result.administrationUrl) {
				window.location.href = result.administrationUrl + '?token=' + result.token;
			} else {
				//  This is the redirect when coming from the site ( not the shop).
				window.location.href = this.successRedirect;
			}
		}, (error) => {
			this.logger.debug('Failed to login', error);
			this.formError = 'Invalid username / password';
		});
	}

	/**
	 * Toggle show/hide password
	 */
	togglePassword() {
		this.passwordFieldType = (this.passwordFieldType === 'password') ? 'text' : 'password';
	}

	hasAcceptedCookies(): boolean {
		return this.cookieService.getCookieByName(CookieBannerComponent.ACCEPTED_COOKIES);
	}

	/**
	 * Returns the url that we need to return to after login. In this case we have two seperate
	 * ways a returnUrl can be set. Either by a queryParam from Angular Router or by a url parameter
	 * from plain javascript.
	 * The Angular Router queryParam has the priority and will be used if both the queryParam and
	 * a url parameter from plain javascript exist.
	 */
	getReturnUrl() {
		const routerReturnUrl = this.route.snapshot.queryParams.returnUrl;
		const windowReturnUrl = this.getReturnUrlFromParameters(this.windowObj.location.search);

		if (routerReturnUrl) {
			return routerReturnUrl;
		}

		return windowReturnUrl || null;
	}

	/**
	 * Get URL Paramaters and expose them as an object.
	 *
	 * @param search
	 */
	getReturnUrlFromParameters(search) {
		const hashes = search.slice(search.indexOf('?') + 1).split('&');
		return hashes[0].replace('returnUrl=', '');
	}

	private showMessage(message: Message) {
		this.applicationService.message = message;
	}
}
